import ShopManageEmployeeSection from './shop-manage-employee-section';

export default ShopManageEmployeeSection;
